import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePicker } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import ManufacturerWriteDTO from '../../../../../../types/manufacturer/ManufacturerWriteDTO';
import { ManufacturerService } from '../../../../services/manufacturer.service';
import { UtilsService } from '../../../../services/utils.service';

@Component({
    selector: 'app-create-manufacturer-dialog',
    templateUrl: './create-manufacturer-dialog.component.html',
    styleUrls: [ './create-manufacturer-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        DatePicker,
        Textarea,
        IftaLabelModule
    ]
})
export class CreateManufacturerDialogComponent implements OnInit {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() manufacturerCreated: EventEmitter<any> = new EventEmitter<any>();

    public manufacturer: ManufacturerWriteDTO = new ManufacturerWriteDTO({});
    public contractExpirationDate: Date | undefined;

    // Loading state
    public loading: boolean = false;

    constructor(
        private manufacturerService: ManufacturerService,
        private messageService: MessageService,
        private utilsService: UtilsService
    ) {
    }

    ngOnInit(): void {
    }

    public get saveDisabled(): boolean {
        return !this.manufacturer.name || !this.manufacturer.mail;
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public saveManufacturer(): void {
        this.loading = true;

        this.manufacturer.contractExpirationDate =
            this.utilsService.convertDateToDateString(this.contractExpirationDate);

        this.manufacturerService.createManufacturer(this.manufacturer)
            .then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Manufacturer created successfully',
                    life: 3000
                });
                this.manufacturerCreated.emit();
                this.close();
            })
            .catch((error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 6000
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
